// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import myw from 'myWorld/base/core';

myw.SuggestionItemView = myw.View.extend({
    tagName: 'li',
    className: 'search-result suggestion-item',

    messageGroup: 'SearchControl',

    events: {
        mouseenter: 'highlight',
        touchstart: 'highlight',
        click: 'choose'
    },

    /*
     * @class Responsible for rendering one suggestion <br/>
     * @param  {integer}             options.index       Position of the item in the parent list
     * @param  {autoCompleteResult}  options.suggestion
     * @param  {SearchControl}   options.owner
     * @param  {string}              options.type        Type of suggestion. Provider title or 'recent'
     * @constructs
     * @extends {Backbone.View}
     */
    initialize(options) {
        myw.View.prototype.initialize.call(this, options);
        this.suggestion = options.suggestion;
        this.dataType = this.suggestion.type;
        this.index = options.index;
        this.owner = options.owner;

        this.listenTo(this.owner, 'change:highlightedIndex', this._toggleSelected);

        this.render();
    },

    render() {
        const searchText = this.owner.getSearchText();
        let label = _.escape(this.suggestion.label);
        let typeIconName;

        if (searchText.length === 0) {
            // Used for recent searches, keep original label
        } else {
            const searchTerms = this._escapeRegExp(this.owner.getSearchText()).split(' '),
                re = new RegExp(searchTerms.join('|'), 'gi');
            //highlight the parts of the label that match the search text
            label = label.replace(re, match => `<span class='text-highlight'>${match}</span>`);
        }

        // Determinea the icon to be used for the list item
        switch (this.dataType) {
            case 'bookmark':
                typeIconName = 'bookmark';
                break;
            case 'query':
            case 'external_query':
                typeIconName = 'query';
                const restriction =
                    this.suggestion.data && this.suggestion.data.spatial_restriction;
                if (restriction) {
                    // add the spacial restriction message
                    label = this.msg(`${restriction}_restriction_label`, { label: label });
                }
                break;
            case 'feature_search':
                if (!label.length) {
                    const moreResultsSrc = myw.baseUrl + 'images/more_results.png';
                    // Adds "..." at the end of the list of objects
                    label = `<img src="${moreResultsSrc}" class="search-result-ellipsis">`;
                    typeIconName = 'blank';
                    this.$el.addClass('search-result-ellipsis-rows');
                } else {
                    typeIconName = 'query';
                    label = this.owner.msg('feature_search', { text: label });
                }
                break;
            case 'placesAc':
                typeIconName = 'location';
                break;
            case 'coordinate':
                typeIconName = 'coordinate';
                break;
            default:
                typeIconName = 'blank';
        }

        const suggestionLabel = $('<span>')
            .attr('title', _.unescape(this.suggestion.label))
            .addClass('search-result-label suggestion-item-label')
            .append($('<img>').attr('src', myw.baseUrl + `images/search/${typeIconName}.svg`))
            .append(label);

        this.$el.empty().append(suggestionLabel);

        this._toggleSelected();
    },

    _toggleSelected() {
        this.$el.toggleClass('selected', this.index === this.owner.highlightedIndex);
    },

    highlight() {
        this.owner.setHighlightedIndex(this.index);
    },

    choose(e) {
        this.owner.app.recordFunctionalityAccess(`core.search.${this.dataType}`);
        this.owner.selectACSuggestion(this.suggestion);
    },

    _escapeRegExp(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    }
});
export default myw.SuggestionItemView;
